export const LocalStorageKey = { USER_DATA: "USER_DATA" };
